
import React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { FaMicrophone, FaComments, FaHandshake, FaHeadset } from 'react-icons/fa';
import { HiOutlineMicrophone } from "react-icons/hi";
import { PiHandshake, PiHandshakeFill, PiHandshakeLight, PiHandshakeThin, PiMicrophone } from "react-icons/pi";
import { TfiCommentAlt } from "react-icons/tfi";
import { FaHeadSideCough } from "react-icons/fa6";
import { BsCheck2Circle, BsHeadset } from "react-icons/bs";

 
export function Accordion1() {
  const [open, setOpen] = React.useState(1);
 
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
 
  return (
    <>
      <div className="services-header mb-2">
        <h2>"Breaking Language Barriers, One Conversation at a Time" </h2>
        <p>At LanguageHelpers, we understand that effective communication is the cornerstone of success in a 
            globalized world. Our professional interpretation services ensure that no message is lost in translation, 
            bridging cultural gaps and fostering understanding across languages. Whether in-person or remote, 
            we provide accurate, timely, and culturally sensitive interpretations to meet your unique needs.
        </p>
      </div>
      <Accordion open={open === 1}>
        <AccordionHeader onClick={() => handleOpen(1)}>
            <p className="flex text-xl font-semibold">
                <PiMicrophone size={52} />
                <span className="mt-3 mx-3">Simultaneous Interpretation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">“Communicate without pauses.” </span>
            Perfect for conferences, webinars, and events where time is crucial. 
            Our interpreters work in real-time, ensuring smooth and seamless communication for your audience.
            {/* <p>&nbsp;</p> */}
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                For conferences, webinars, and events.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Real-time translation as participants speak.
            </p>
        </AccordionBody>
      </Accordion>

      <Accordion open={open === 2}>
        <AccordionHeader className="" onClick={() => handleOpen(2)}>
            <p className="flex text-xl font-semibold">
                <TfiCommentAlt size={40} className="m-2.5" />
                <span className="mt-3 mx-3">Consecutive Interpretation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">“Clarity and accuracy, one step at a time.” </span>
            Ideal for interviews, medical consultations, or small meetings, where every word counts. 
            Our interpreters deliver precise translations after each speaker's sentence or thought.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Ideal for meetings, interviews, and smaller gatherings.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Interpreter translates after the speaker finishes a sentence or thought.
            </p>
        </AccordionBody>
      </Accordion>
      <Accordion open={open === 3}>
        <AccordionHeader onClick={() => handleOpen(3)}>
            <p className="flex text-xl font-semibold">
                <PiHandshakeFill size={42} className="m-2" />
                <span className="mt-3 mx-3">On-Site Interpretation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">“Bringing expertise to your location.” </span>
            For legal, medical, or business meetings, our interpreters provide professional, 
            in-person support to ensure all parties understand and connect effectively.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Professional interpreters present in person.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Perfect for courtrooms, hospitals, and business negotiations.
            </p>
        </AccordionBody>
      </Accordion>
      <Accordion open={open === 4}>
        <AccordionHeader onClick={() => handleOpen(4)}>
            <p className="flex text-xl font-semibold">
                <BsHeadset size={44} className="m-2" />
                <span className="mt-3 mx-3">Remote Interpretation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">“Your solution, anywhere in the world.” </span>
            Cost-effective and accessible, our remote services connect you with 
            certified interpreters via video or phone for instant support.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Conducted via video or phone.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Accessible, cost-effective, and convenient for any location.
            </p>
        </AccordionBody>
      </Accordion>
    </>
  );
}